import { render } from "./ToDoWidget.vue?vue&type=template&id=95fa14c6&ts=true"
import script from "./ToDoWidget.vue?vue&type=script&lang=ts"
export * from "./ToDoWidget.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__